
import { motion } from "framer-motion";
import { AuthForm } from "@/components/auth/AuthForm";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Seo from "@/components/seo/Seo";

const Auth = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      <Seo
        title="Sign in or create an account"
        description="Sign in or create a free Grade Test Pro account to practice AI-powered tests, worksheets, and writing for grades 1–9."
        canonicalPath="/auth"
      />
      <Header />
      
      <main className="flex-1 pt-20">
        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-center">
              <motion.div 
                className="flex-1"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
              >
                <h1 className="text-4xl font-bold mb-4">
                  Welcome to Grade Test Pro
                </h1>
                <p className="text-xl text-muted-foreground mb-6">
                  Sign in or create an account to start practicing for your provincial tests
                </p>
                
                <div className="glass-card p-6 rounded-xl bg-blue-100/40 mb-8">
                  <h3 className="text-lg font-medium mb-2">Why create an account?</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Track your progress over time
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Save your test results
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Get personalized recommendations
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Access from any device
                    </li>
                  </ul>
                </div>
              </motion.div>
              
              <motion.div 
                className="flex-1 w-full max-w-md"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <AuthForm />
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Auth;
